const onerrorSrc = '/assets/images/onerror.png'

const differ = (initialState, newState) => {
  const changedEntries = {}
  for (const key in newState) {
    if (JSON.stringify(newState[key]) !== JSON.stringify(initialState[key])) {
      changedEntries[key] = newState[key]
    }
  }

  return changedEntries
}

const fip = async (any) => {
  // first imageUrl or presignedUrl
  if (any instanceof File) {
    return await readFileAsDataURL(any)
  }
  const item = Array.isArray(any) ? any[0] : any
  return item?.presignedUrl || item?.location || onerrorSrc
}

const readFileAsDataURL = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      resolve(reader.result)
    }
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}
const formatBytes = (bytes) => {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return Math.floor(bytes / Math.pow(k, i)) + ' ' + sizes[i]
}

export default { differ, fip, readFileAsDataURL, formatBytes, onerrorSrc }
